import styled from "styled-components"
import theme from "../../theme"

const ModalBackground = styled<any, "div">("div")`
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background: ${theme.colors.modalBackground};
`

export default ModalBackground
